import { path, createCachedSelector, defaultKeySelector } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { SidebarOpenMode } from '../detailsSidebar.interface';
import { detailsSidebarStoreSelector } from '../detailsSidebar.selector';

export const isDetailsSidebarShownSelector = createCachedSelector(
  [
    path(detailsSidebarStoreSelector).mode(),
  ],
  (mode) => {
    return mode !== SidebarOpenMode.None;
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
